import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const informationPageCompanyInformationSectionK = {
  paymentTerms: "information_page_company_information_section.paymentTerms",
  balance: "information_page_company_information_section.balance",
  payment: "information_page_company_information_section.payment",
  balanceDue: "information_page_company_information_section.balanceDue",
  telephone: "information_page_company_information_section.telephone",
  city: "information_page_company_information_section.city",
  currency: "information_page_company_information_section.currency",
  editCustomerDialogHeadingTitle: "information_page_company_information_section.editCustomerDialogHeadingTitle",
  company: "information_page_company_information_section.company",
  thirtyDays: "information_page_company_information_section.thirtyDays",
  dkk: "information_page_company_information_section.dkk",
  address: "information_page_company_information_section.address",
  postCode: "information_page_company_information_section.postCode",
  streetName: "information_page_company_information_section.streetName",
  eur: "information_page_company_information_section.eur",
  email: "information_page_company_information_section.email",
  name: "information_page_company_information_section.name",
  editInformation: "information_page_company_information_section.editInformation",
  usd: "information_page_company_information_section.usd",
  sixtyDays: "information_page_company_information_section.sixtyDays",
  country: "information_page_company_information_section.country",
  contact: "information_page_company_information_section.contact",
  cvr: "information_page_company_information_section.cvr",
};

export const useInformationPageCompanyInformationSectionT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      paymentTerms: t(informationPageCompanyInformationSectionK.paymentTerms),
      balance: t(informationPageCompanyInformationSectionK.balance),
      payment: t(informationPageCompanyInformationSectionK.payment),
      balanceDue: t(informationPageCompanyInformationSectionK.balanceDue),
      telephone: t(informationPageCompanyInformationSectionK.telephone),
      city: t(informationPageCompanyInformationSectionK.city),
      currency: t(informationPageCompanyInformationSectionK.currency),
      editCustomerDialogHeadingTitle: t(informationPageCompanyInformationSectionK.editCustomerDialogHeadingTitle),
      company: t(informationPageCompanyInformationSectionK.company),
      thirtyDays: t(informationPageCompanyInformationSectionK.thirtyDays),
      dkk: t(informationPageCompanyInformationSectionK.dkk),
      address: t(informationPageCompanyInformationSectionK.address),
      postCode: t(informationPageCompanyInformationSectionK.postCode),
      streetName: t(informationPageCompanyInformationSectionK.streetName),
      eur: t(informationPageCompanyInformationSectionK.eur),
      email: t(informationPageCompanyInformationSectionK.email),
      name: t(informationPageCompanyInformationSectionK.name),
      editInformation: t(informationPageCompanyInformationSectionK.editInformation),
      usd: t(informationPageCompanyInformationSectionK.usd),
      sixtyDays: t(informationPageCompanyInformationSectionK.sixtyDays),
      country: t(informationPageCompanyInformationSectionK.country),
      contact: t(informationPageCompanyInformationSectionK.contact),
      cvr: t(informationPageCompanyInformationSectionK.cvr),
    }),
    [i18n.language]
  );
};